import type { SkillTypes } from "@memorang/types";
import { Button, Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import Box from "../../../Box";
import { stimulusIconMap } from "../../StimulusInfo";

type Props = {
	title: string;
	openCta?: string;
	skill: SkillTypes;
	stimulusCaption?: string;
	trailingCaption?: string;
	onPress?: () => void;
};

const PassageBanner = ({
	title,
	openCta,
	skill,
	stimulusCaption,
	trailingCaption,
	onPress,
}: Props) => {
	const theme = useAppTheme();
	const stimulusIcon = stimulusIconMap[skill];
	const hasOpenButton = Boolean(openCta && onPress);

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			paddingVertical={hasOpenButton ? 8 : 16}
			paddingHorizontal={16}
			marginTop={-16}
			marginHorizontal={-16}
			gap={8}
			backgroundColor={theme.colors.surface}
			style={{
				borderRadius: theme.roundness * 2,
				minHeight: hasOpenButton ? 70 : 56,
				borderTopWidth: 1,
				borderTopColor: theme.colors.surfaceVariant,
				borderBottomWidth: 1,
				borderBottomColor: theme.colors.surfaceVariant,
			}}
		>
			<Box flex={1} gap={2}>
				<Text variant="titleMedium" numberOfLines={1}>
					{title}
				</Text>

				{stimulusCaption ? (
					<Text variant="bodySmall">{stimulusCaption}</Text>
				) : null}
			</Box>
			{trailingCaption ? (
				<Text variant="bodySmall">{trailingCaption}</Text>
			) : null}
			{hasOpenButton ? (
				<Button
					mode="outlined"
					icon={stimulusIcon}
					onPress={onPress}
					compact
					style={{ borderRadius: theme.roundness * 10 }}
					labelStyle={{ fontSize: 14, fontWeight: "600" }}
				>
					{openCta}
				</Button>
			) : null}
		</Box>
	);
};

export default PassageBanner;
